var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeistungenPapa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.25 788.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .17;\n      }\n\n      .cls-2 {\n        opacity: .6;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-19 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #f8e0d5;\n      }\n\n      .cls-4 {\n        fill: #5f5166;\n      }\n\n      .cls-5 {\n        fill: #834f80;\n      }\n\n      .cls-6 {\n        fill: #4ca8e3;\n      }\n\n      .cls-7 {\n        fill: #2c2334;\n      }\n\n      .cls-8 {\n        fill: #463a4f;\n      }\n\n      .cls-9 {\n        fill: #3c2534;\n      }\n\n      .cls-10 {\n        fill: #d24a46;\n      }\n\n      .cls-11 {\n        fill: #e1c4b6;\n      }\n\n      .cls-12 {\n        fill: #9f3935;\n      }\n\n      .cls-13 {\n        fill: #332938;\n      }\n\n      .cls-14 {\n        fill: #7d5978;\n      }\n\n      .cls-15 {\n        fill: #9eb9dc;\n      }\n\n      .cls-16 {\n        fill: #a15a5f;\n      }\n\n      .cls-17 {\n        fill: #947366;\n      }\n\n      .cls-18 {\n        fill: #ff805e;\n      }\n\n      .cls-20 {\n        fill: #eecfc0;\n      }\n\n      .cls-21 {\n        fill: #ffe5da;\n      }\n\n      .cls-22 {\n        fill: #ffc578;\n      }\n\n      .cls-23 {\n        fill: #f35752;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 138.24,
    cy: 777.85,
    rx: 138.24,
    ry: 10.27
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m137.71,245.32l54.89,14.15,10.58-52.54-56.73-10.2c-13.42-2.41-26.25,6.51-28.67,19.93h0c-2.41,13.42,6.51,26.25,19.93,28.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m192.57,76.39h0c-2.33-6.23-9.28-9.4-15.51-7.06l-46.69,17.48,8.45,22.58,46.69-17.48c6.23-2.33,9.4-9.28,7.06-15.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m179.67,88.32h0c-5.83-3.21-7.96-10.54-4.75-16.37l25.64-26.99,12.04,6.62-16.55,31.99c-3.21,5.83-10.54,7.96-16.37,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m203.53,23.21h8.76c6.48,0,11.74,5.26,11.74,11.74v9.35c0,4.93-4,8.92-8.92,8.92h-4.72c-6.48,0-11.74-5.26-11.74-11.74v-13.39c0-2.7,2.19-4.88,4.88-4.88Z",
    transform: "translate(163.87 -171.23) rotate(66.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m178.08,101.7l-10.76-28.74-38.45,14.39c-7.94,2.97-11.96,11.81-8.99,19.75h0c2.97,7.94,11.81,11.96,19.75,8.99l38.45-14.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m42.39,161.1h0c4.84,4.57,12.47,4.36,17.04-.48l34.25-36.22-17.52-16.56-34.25,36.22c-4.57,4.84-4.36,12.47.48,17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m151.12,126.68l7.52,66.95-3.11,10.82-.08,10.25-91.24-12.61-4.02-9.84,9.77-18.64-.17-50.51c.74-17.71,8.97-32.44,24.52-38.39.18-.07.36-.14.55-.19,2.34-.89,4.77-1.54,7.28-1.99,3.03-.54,6.15-.76,9.33-.62,5.4.22,10.52,1.43,15.21,3.44,2.02.87,3.97,1.89,5.8,3.04,12.68,7.95,19.3,22.29,18.63,38.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "69.38 150.01 82.48 137.42 69.94 167.25 69.38 150.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m45.03,134.04l23.68,19.52,26.11-31.68c5.39-6.54,4.46-16.21-2.08-21.6h0c-6.54-5.39-16.21-4.46-21.6,2.08l-26.12,31.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m35.63,156.52l-25.83-41.91,12.34-9.76,34.61,35.56c5.11,5.52,4.65,14.17-1.02,19.12h0c-6.19,5.41-15.76,3.98-20.1-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m22.71,93.28h4.72c4.93,0,8.93,4,8.93,8.93v9.35c0,6.48-5.26,11.74-11.74,11.74h-8.76c-2.7,0-4.88-2.19-4.88-4.88v-13.4c0-6.48,5.26-11.74,11.74-11.74Z",
    transform: "translate(11.44 218.46) rotate(-161.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m128.11,98.45c-6.8,1.95-28.17-10.1-33.24-13.95,2.34-.89,4.77-1.54,7.28-1.99,3.03-.54,6.15-.76,9.33-.62,5.4.22,10.52,1.43,15.21,3.44,4.15,3.39,7.77,11.29,1.42,13.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m149.87,7.53c1.61,3.32-3,8.88-10.31,12.42-7.3,3.54-14.52,3.72-16.13.4-1.61-3.32,3-8.88,10.31-12.42,7.3-3.54,14.52-3.72,16.13-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m154.84,24.17c-.39,3.67-7.25,5.94-15.32,5.09-8.07-.86-14.29-4.53-13.9-8.2.39-3.67,7.25-5.94,15.32-5.09,8.07.86,14.29,4.53,13.9,8.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 117.78,
    cy: 41.35,
    r: 33.49,
    transform: "translate(12.67 108.69) rotate(-51.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m136.23,2.38c1.61,3.32-3,8.88-10.31,12.42-7.3,3.54-14.52,3.72-16.13.4-1.61-3.32,3-8.88,10.31-12.42,7.3-3.54,14.52-3.72,16.13-.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 101.99,
    y: 70.6,
    width: 24.6,
    height: 14.74,
    transform: "translate(211.34 176.57) rotate(-168.84)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "125.64 84 127 77.07 107.31 73.19 125.64 84"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m152.22,41.77l.21,21.08c.12,11.95-19.29,17.13-19.29,17.13-14.73.15-36.14-6.89-36.28-21.62l-.16-16.03c-.15-14.63,12.15-26.62,27.49-26.77,7.67-.08,14.65,2.83,19.71,7.57,5.07,4.74,8.25,11.34,8.32,18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m130.19,44.37s-.98-.66-2.6-.66h-.06c-1.68.01-2.68.65-2.69.66l-.71-1.08c.05-.03,1.31-.85,3.39-.87h.08c2.05,0,3.29.86,3.34.89l-.75,1.06.38-.53-.37.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m145.74,44.15l-.78-1.03s1.17-.87,3.01-.9h.07c1.82,0,2.92.88,2.97.92l-.82,1.01s-.81-.63-2.15-.63h-.05c-1.39.02-2.23.63-2.24.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m132.88,62.91c.05,4.6,2.98,8.31,6.56,8.27,3.58-.04,6.44-3.8,6.4-8.4l-12.96.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m152.29,48.68l.15,14.94c-.08.01-.17.02-.25.02-3.65.04-6.66-3.29-6.7-7.42-.04-4.14,2.9-7.51,6.55-7.55.08,0,.17,0,.25.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m99.12,44.38h0c8.93-.09,16.09-7.4,16-16.32l-.03-3.04c-.03-3.36-2.78-6.05-6.14-6.02l-10.09.1c-3.36.03-6.05,2.78-6.02,6.14l.13,13.13c.03,3.36,2.78,6.05,6.14,6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m130.24,56.6c.04,4.38-3.47,7.97-7.85,8.01-4.38.04-7.97-3.47-8.01-7.85-.04-4.38,3.47-7.97,7.85-8.01,4.38-.04,7.97,3.47,8.01,7.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m130.17,49.62c.01,1.38-1.1,2.52-2.48,2.53-1.38.01-2.52-1.1-2.53-2.48-.01-1.38,1.1-2.52,2.48-2.53,1.38-.01,2.52,1.1,2.53,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m150.53,49.42c.01,1.38-1.1,2.52-2.48,2.53-1.38.01-2.52-1.1-2.53-2.48-.01-1.38,1.1-2.52,2.48-2.53,1.38-.01,2.52,1.1,2.53,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m141.52,59.85c.32,0,.69-.15.97-.43.33-.33.49-.78.43-1.24v-1.62s-1.32,0-1.32,0l-.03,1.91h-.05s-.19.04-.19.04l-3.09.04.02,1.32,3.09-.04c.06,0,.12.02.18.01Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m112.96,14.09h23.44v8.45h-29.43v-2.46c0-3.31,2.69-5.99,5.99-5.99Z",
    transform: "translate(243.54 35.42) rotate(179.43)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m104.94,52.59c1.22,6.89-3.38,13.46-10.26,14.67-6.89,1.22-13.46-3.38-14.67-10.26-1.22-6.89,3.38-13.46,10.26-14.67,6.89-1.22,13.46,3.38,14.67,10.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m136.74,142.15c-4.12,2.9-8.23,5.81-12.35,8.71-.81.57-.04,1.91.78,1.33,4.12-2.9,8.23-5.81,12.35-8.71.81-.57.04-1.91-.78-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m141.58,145.84c-2.24,1.63-4.47,3.26-6.71,4.89-.8.58-.03,1.92.78,1.33,2.24-1.63,4.47-3.26,6.71-4.89.8-.58.03-1.92-.78-1.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m18.19,761.02l93.57,18.29s.97-2.96,1.45-7.42c.06-.73.12-1.52.17-2.34.33-6.27-.59-14.56-5.85-21.7-.84-1.16-1.8-2.27-2.87-3.35-10.21-10.2-15.54-14.98-12.17-29.75l7.71-33.78-61.01-11.93-21,91.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m58.58,709.81s-7.43-.83-9.98,6.38c-2.55,7.2-21.34,5.13-21.34,5.13l3.51-15.38,27.81,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.39,769.56c-.04.82-.11,1.6-.18,2.34l-93.34-18.25.52-2.27,93,18.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 78.56,
    y: 719.92,
    width: 2.39,
    height: 26.11,
    transform: "translate(-654.9 670.6) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 75.86,
    y: 713.75,
    width: 2.39,
    height: 26.11,
    transform: "translate(-651.04 662.97) rotate(-78.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 73.15,
    y: 707.58,
    width: 2.39,
    height: 26.11,
    transform: "translate(-647.16 655.33) rotate(-78.94)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m31.86,754.38l1.71,1.4c-.47.46,18.44-17.47,33.56-14.52l41.44,8.1c-.58-.94-1.22-1.87-1.97-2.76l-38.6-7.55c-16.57-3.24-35.98,15.16-36.14,15.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m41.92,558.81L6.54,702.47l85.97,12.31s42.08-135.81,42.18-136.42c6.73-39.39-81.55-83-92.76-19.55Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "201.43 269.78 232.24 337.89 184.52 358.86 201.43 269.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m245.67,279.18l-31.66,36.14c-23.09,18-36.33,38.19-20.85,55.44,15.48,17.25,37.09,11.35,47.58-7.01l26.14-72.7-21.21-11.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "71.51 444.71 186.02 619.56 261.41 552.11 184.37 409.78 71.51 444.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 138.98,
    y: 428.86,
    width: 2.33,
    height: 57.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m140.75,476.78h-.61v-2.33h.61c8.53,0,15.47-6.94,15.47-15.47v-30.12h2.33v30.12c0,9.82-7.99,17.81-17.81,17.81Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m165.77,779.32h95.82s-.2-3.49-.74-8.08c-.12-.74-.23-1.55-.37-2.38-1.08-6.32-3.79-14.37-10.38-20.5-.51-.48-1.04-.95-1.6-1.4v-.02c-.43-.33-.85-.65-1.29-.97-.28-.21-.57-.4-.87-.6-11.3-7.58-17.51-11.38-18.44-24.12-.09-1.06-.14-2.2-.15-3.41l-.12-11.64-62.18-1.13.32,74.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m193.35,720.42s-7.73,1.58-9.35,9.05c-1.62,7.47-18.38,6.93-18.38,6.93l-.05-16.51,27.78.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m163.73,719.84l81.96,2.14,19.16-126.02.73-4.76,1.76-11.63c-.06-19.28-7.27-36.28-20.07-46.58h0s-.12-.09-.12-.09c-1.02-.81-2.06-1.6-3.15-2.32-2.78-1.88-5.82-3.47-9.08-4.72h-.02c-1.18-.45-2.39-.87-3.65-1.23-4.57-1.34-9.5-2.04-14.8-2.02l-40.56,47.6-12.17,149.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "180.76 720.28 178.12 720.21 191.98 590.2 129.55 505.51 131.69 503.93 194.73 589.46 194.67 589.97 180.76 720.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m260.49,768.85c.15.84.26,1.64.35,2.39l-95.11.3v-2.39s94.75-.3,94.75-.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "207.86 738.12 207.87 740.51 233.98 740.43 233.97 738.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 202.98,
    y: 732.41,
    width: 26.11,
    height: 2.39,
    transform: "translate(-2.02 .6) rotate(-.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 198.1,
    y: 726.75,
    width: 26.11,
    height: 2.39,
    transform: "translate(-2.01 .59) rotate(-.16)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m179.12,769.5l2.14,1.07c.11-.22,11.22-22.04,26.62-22.09l42.23-.13c-.9-.83-1.86-1.63-2.9-2.38l-39.33.12c-16.89.05-28.28,22.45-28.76,23.41Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "34.63 460.87 41.92 583.97 80.83 574.51 82.87 574.63 134.24 579.43 135.35 502.67 135.13 457.44 34.63 460.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "21.67 704.64 19.03 704.26 52.17 571.11 41.6 457.56 44.25 457.31 54.86 571.31 21.67 704.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m215.34,462.92l-184.69,5.83,30-202.52c1.97-15.82,11.96-29.51,26.44-36.21l31.04-16.81,29.14,8.43s53.52,37.85,55.5,51.73l12.58,189.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m99.9,276.14l-49.75,85.96c-5.75,8.39-17.48,9.97-25.25,3.41l-3.91-3.3c-10.51-8.88-13.26-23.95-6.57-35.96l36.64-65.84,48.84,15.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.56,308.49l59.06,26.61,30.96-48.82c8.77-13.57,6.36-31.51-5.69-42.27h0c-15.29-13.66-39.22-10.1-49.88,7.41l-34.45,57.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m110.71,217.23l10.34-33.46,35.08,10.6-9.93,30.56s-.25,7.95-13.26,6.96c-11.91-.91-22.25-14.66-22.25-14.66h.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "164.44 480.68 125.88 480.09 135.49 508.37 164.44 480.68"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m105.92,284s-59.6,20.64-88.97,45.64c-5.13,4.37-7.57,11.18-6.15,17.77,2.09,9.7,8.66,22.21,28.62,22.15,32.55-.1,82.67-67.53,82.67-67.53l-16.17-18.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m196.94,126l-20.88,14.76,1-3.3.44-1.42,1.29-4.24,1.06-3.53,9.48-31.21,5,8.65.89,1.56,4.23,7.32c.36.62.64,1.27.82,1.92.17.56.27,1.12.32,1.7.24,2.97-1.06,5.97-3.65,7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m195.22,107.26c-4.67,8.73-9.74,17.24-16.44,24.53-1.06,1.15-2.17,2.29-3.32,3.38-.71.67-1.77-.39-1.08-1.08,1.95-1.85,3.77-3.8,5.45-5.83,5.77-6.85,10.29-14.62,14.48-22.56l.89,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m200.59,118.2c-1.56,1.33-3.11,2.68-4.65,4-5.94,5.09-11.88,10.18-17.82,15.27-.35.3-.79.21-1.06-.02-.29-.27-.38-.71,0-1.05.15-.12.29-.26.44-.38,6.15-5.3,12.33-10.57,18.48-15.86,1.42-1.23,2.85-2.45,4.29-3.67.17.56.27,1.12.32,1.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "199.58 158.69 185.06 155.93 185.55 159.37 198.91 163.44 199.58 158.69"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 149.22,
    cy: 152.29,
    r: 39.95,
    transform: "translate(-22.47 25.87) rotate(-9.22)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m165.53,209.89l-11.54-2.01c-19.22-3.34-33.25-20.02-33.25-39.52v-14.02c0-17.46,14.83-31.61,33.12-31.61h0c18.29,0,33.12,14.15,33.12,31.61v37.64c0,13.06-9.23,20.24-21.44,17.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m146.42,152.13l-1.51-2.8c2.94-1.59,6.38-2.26,9.71-1.87l-.36,3.17c-2.68-.3-5.46.23-7.83,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m174.23,152.13l-1.52-2.8c2.94-1.59,6.39-2.26,9.71-1.87l-.36,3.17c-2.69-.3-5.46.23-7.83,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m148.55,163.5l-1.29-.24c.03-.15.75-3.73,6.41-4.27l.12,1.31c-4.68.45-5.24,3.17-5.24,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m174.83,163.44l-1.29-.24c.03-.15.75-3.73,6.41-4.27l.12,1.31c-4.68.45-5.24,3.17-5.24,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m186.98,168.09v11.91c-.44.05-.89.08-1.35.08-4.67,0-8.44-2.7-8.44-6.03s3.77-6.03,8.44-6.03c.45,0,.91.03,1.35.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 114.71,
    cy: 167.39,
    r: 15.1,
    transform: "translate(-74.56 240.58) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m186.98,208.34c-.76,1.17-2.3,2.91-4.56,4.67-.39.29-.8.59-1.24.89-1.8,1.23-3.97,2.42-6.5,3.35-.48.18-.97.33-1.47.48-2.02.64-4.23,1.08-6.64,1.24-.5.05-1,.08-1.51.08-2.5.08-5.2-.17-8.07-.79-.49-.11-.97-.21-1.47-.35-4.18-1.08-8.73-2.97-13.62-5.97-6.58-4.03-11.17-8.51-14.36-12.95-.3-.41-.59-.83-.86-1.26-.89-1.33-1.65-2.65-2.3-3.95-.24-.47-.45-.92-.67-1.38-1.09-2.41-1.83-4.73-2.33-6.86-.12-.51-.23-1.02-.32-1.5-1.14-6.15-.27-10.45-.27-10.45h10.86s.47,1.44,1.27,3.35c.18.45.39.95.64,1.45.53,1.17,1.17,2.42,1.86,3.58.29.47.58.91.88,1.33.3.41.59.77.91,1.12.36.42.74.79,1.14,1.09.91.7,1.86,1.05,2.85.8,5.01-1.2,28.68-7.04,28.68-7.04l17.12,7.04s4.03,15.82,0,22.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m163.74,187.98c-1.05,10.36-3.29,20.48-6.76,30.28-.49-.11-.97-.21-1.47-.35,3.42-9.68,5.68-19.68,6.71-29.94.11-.97,1.62-.97,1.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m166.58,218.98c-.5.05-1,.08-1.51.08-.03-9.74-.05-19.45-.08-29.18,0-.97,1.51-.97,1.51,0,.03,9.7.05,19.39.08,29.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m174.68,217.25c-.48.18-.97.33-1.47.48-1.14-10.54-2.29-21.09-3.44-31.63-.11-.97,1.41-.95,1.51,0,1.12,10.38,2.26,20.77,3.39,31.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m182.42,213.01c-.39.29-.8.59-1.24.89-4.18-8.73-7.21-17.92-9.01-27.48-.18-.95,1.27-1.35,1.45-.39,1.77,9.38,4.71,18.41,8.8,26.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m138.34,185.51c-2.76,5.17-6.41,9.71-10.8,13.48-.3-.41-.59-.83-.86-1.26,4.3-3.73,7.85-8.21,10.53-13.32.36.42.74.79,1.14,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m136.29,183.3c-3.3,4.21-7.47,7.53-11.92,10.48-.24-.47-.45-.92-.67-1.38,4.39-2.92,8.51-6.21,11.71-10.44.29.47.58.91.88,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m133.55,178.39c-3.7,2.98-7.85,5.24-12.18,7.15-.12-.51-.23-1.02-.32-1.5,4.23-1.88,8.27-4.12,11.86-7.11.18.45.39.95.64,1.45Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 145.42,
    cy: 173.28,
    rx: 8.43,
    ry: 6.03
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m156.62,184.72l20.57-.94s-10.99,16.96-20.57.94Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 152.21,
    cy: 163.44,
    r: 2.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 178.37,
    cy: 163.44,
    r: 2.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m168.93,177.44c.58,0,1.25-.26,1.77-.76.61-.59.91-1.41.8-2.25l.02-2.94h-2.39s-.09,3.46-.09,3.46l-.1-.02-.34.08-5.61.02v2.39s5.62-.02,5.62-.02c.1.02.21.03.32.03Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m167.04,179.3c-.71,1.86,2.44,4.8,7.04,6.57,4.6,1.77,8.91,1.69,9.63-.17.71-1.86-2.44-4.8-7.04-6.57-4.6-1.77-8.91-1.69-9.63.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m148.62,184.45c.46,1.94,5.32,2.46,10.85,1.15,5.53-1.31,9.64-3.95,9.18-5.9-.46-1.94-5.32-2.46-10.85-1.15-5.53,1.31-9.64,3.95-9.18,5.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "120.78 173.6 131.64 173.6 131.64 125.89 117.39 126.97 120.78 173.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m202.42,157.72c-.07-.1-.22-.2-.42-.32-.05-.03-.11-.06-.17-.09-.28-.14-.63-.29-1.06-.44-.09-.03-.19-.07-.29-.1-.46-.16-.99-.32-1.58-.49-.07-.02-.14-.04-.22-.06-.02,0-.04-.01-.06-.02-.05-.01-.11-.03-.16-.04-.27-.07-.55-.15-.84-.22-.08-.02-.16-.04-.24-.06-.03,0-.06-.02-.09-.02-.08-.02-.16-.04-.25-.06-.13-.03-.26-.06-.4-.1-.2-.05-.41-.1-.62-.15-.05,0-.1-.02-.15-.03-.69-.16-1.42-.31-2.16-.46-1.27-.26-2.6-.49-3.93-.69-.03,0-.06,0-.09-.01-.19-.03-.39-.06-.58-.09-.07,0-.14-.02-.21-.03-.66-.09-1.31-.16-1.94-.22-5.39-.46-9.85.35-12.3,1.17-2.67.89-8.05,1-8.33,1.01-.28-.01-5.65-.23-8.3-1.17-2.72-.98-7.96-1.97-14.22-1.23-3.73.44-7.6,1.19-10.25,1.9-.75.2-1.4.4-1.92.59-.31.11-.57.22-.79.32h0c-.31.15-.52.28-.61.4-.47.62-.57,1.63-.22,2.57.16.42.41.83.75,1.19.11.11.24.22.37.33.17.13.33.41.49.81.76,1.95,1.38,6.69,2.44,10.27.54,1.82,1.18,3.34,2.02,4.04,1.57,1.32,3.37,2.08,5.46,2.44,1.66.28,3.51.31,5.58.15.89-.07,1.82-.2,2.77-.4,3-.64,6.14-2.01,8.33-4.39,1.09-1.18,1.95-2.61,2.45-4.32,1.81-6.24,3.14-8.19,3.87-8.63.56-.33,1.29-.36,1.6-.35.06,0,.1,0,.13,0h.03c.16,0,1.06-.02,1.72.38.72.44,2.02,2.42,3.7,8.7,1.01,3.77,3.79,6.22,6.96,7.68.38.17.77.34,1.15.48,1.76.67,3.59,1.06,5.26,1.22.65.06,1.27.11,1.87.13,0,0,0,0,0,0,.16,0,.33.01.49.01.58.01,1.15,0,1.69-.03,0,0,0,0,0,0,.49-.03.97-.07,1.43-.14,0,0,0,0,0,0,.28-.04.55-.09.82-.14,0,0,0,0,0,0,.54-.11,1.05-.25,1.55-.42.08-.03.17-.06.25-.09.33-.12.65-.26.96-.41.71-.34,1.37-.76,2.01-1.27,2.86-2.3,3.78-13.94,5.24-15.01.15-.11.29-.23.41-.36.66-.67.97-1.53.97-2.32h0c0-.53-.13-1.03-.4-1.39Zm-45.17,14.45c-.66.83-1.4,1.56-2.21,2.11-.49.34-1.04.67-1.65.97-3.47,1.77-8.64,2.87-13.52,1.21-1.09-.37-1.96-.98-2.64-1.75-.64-.72-1.12-1.59-1.48-2.55-1.27-3.39-1.02-7.9-.89-11.11.18-4.59,4.68-5.05,7.26-5.46,8.17-1.3,15.43.37,17.8,3.09,1.98,2.27.67,9.27-2.67,13.49Zm40.37-4.13c-.04.4-.08.81-.14,1.21-.02.15-.04.31-.07.46-.04.24-.08.48-.13.71-.03.15-.06.3-.1.45,0,0,0,0,0,0-.03.15-.07.3-.11.45,0,0,0,0,0,0-.04.15-.08.29-.12.44-.31,1.05-.74,2.01-1.33,2.84-.07.1-.15.2-.22.29-.17.22-.36.43-.57.63-.03.03-.05.05-.08.07-.38.36-.81.68-1.3.93-.13.07-.26.13-.4.19-.21.09-.42.17-.65.24-1.7.54-3.42.75-5.09.72-.07,0-.14,0-.21,0-.04,0-.08,0-.11,0,0,0,0,0,0,0-2.13-.08-4.17-.55-5.95-1.22-1.46-.55-2.73-1.24-3.74-1.96-.02-.02-.05-.03-.07-.05-4.8-3.51-6.92-12.99-4.51-15.64,2.07-2.27,7.64-3.71,14.27-3.2.67.05,1.35.12,2.04.22t0,0c.11.01.23.03.34.05.13.02.27.04.4.06.13.02.27.04.4.07.13.02.27.05.41.07.3.05.63.11.98.17.11.02.23.04.34.06.2.04.41.08.61.13.08.02.17.04.25.06.08.02.15.04.23.06.06.01.12.03.19.05.46.13.93.28,1.37.47.08.04.17.07.25.11,0,0,.01,0,.02,0,.09.04.17.08.26.13.05.03.1.05.15.08.04.02.08.05.12.07.09.05.19.11.28.17.04.02.07.05.11.07.13.09.26.19.39.3h0c.93.79,1.57,1.94,1.6,3.65,0,.45.02.92.03,1.41h0c.02,1.54.03,3.26-.13,4.96Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "133.56 155.7 119.04 152.94 119.53 156.38 132.89 160.45 133.56 155.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m182.06,129.55s-16.45-5.42-25.95,7.67c-6.08,8.41-14.68,8.44-22.38,7.36-.05,0-.1-.01-.15-.02-.84-.11-1.66-.24-2.46-.37,0,0,0,0-.01,0-2.13-.34-4.15-.71-5.98-.93-.59-.07-1.17-.13-1.72-.16-.39-.03-.77-.04-1.13-.04-2.99,0-6.94-.41-10.84-.94-.77-.1-1.54-.22-2.3-.33-1.37-.2-2.7-.42-3.95-.62-.64-.1-1.26-.21-1.85-.32-2.1-.36-3.86-.7-5.03-.91-.97-.2-1.52-.3-1.52-.3,0,0,.01-.23.08-.67.25-1.83,1.23-7.23,4.53-13.67.3-.59.62-1.19.97-1.79,3.52-6.21,9.21-13.13,18.41-18.65,1.88-1.13,4.61-1.97,7.89-2.59.59-.11,1.19-.21,1.82-.31.62-.1,1.25-.19,1.9-.27.61-.09,1.21-.17,1.85-.23,3.86-.42,8.12-.64,12.44-.73.49,0,.98-.02,1.47-.03,1.43-.02,2.87-.02,4.3-.02.52,0,1.03,0,1.54.01,1.63.02,3.24.05,4.82.09,1.11.03,2.18.06,3.24.09,1.11.04,2.18.09,3.23.14,1.24.06,2.44.12,3.56.18,1.28.07,2.49.14,3.59.21.62.04,1.2.08,1.76.11,3.62.24,5.84.45,5.84.45,4.67,4.73,2.03,27.56,2.03,27.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m153.99,100.72c-.13.23-.25.47-.38.7-5.7,10.5-12.1,20.63-19.17,30.26-2.9,3.95-5.93,7.95-9.31,11.57-.59-.07-1.17-.13-1.72-.16,1.57-1.64,3.07-3.35,4.49-5.11,3.66-4.5,7.06-9.22,10.33-14.01,5.13-7.51,9.87-15.28,14.21-23.27.52,0,1.03,0,1.54.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m174.18,101.54c-2.16,2.06-3.33,4.86-4.72,7.45-4.75,8.91-10.9,17.17-18.43,23.93-3.72,3.34-7.75,6.36-12.09,8.85-1.75,1.01-3.53,1.94-5.37,2.79-.84-.11-1.66-.24-2.46-.37.99-.4,1.95-.87,2.86-1.31,2.54-1.24,5.01-2.63,7.37-4.18,8.55-5.61,15.82-13.08,21.58-21.51,1.43-2.1,2.79-4.26,4.04-6.47,1.26-2.23,2.32-4.58,3.64-6.78.54-.89,1.13-1.74,1.81-2.51.62.04,1.2.08,1.76.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m148.15,100.72c-.03.09-.07.18-.1.27-2.03,5.07-5.04,9.75-8.14,14.23-2.95,4.25-6.15,8.35-9.69,12.12-3.52,3.75-7.34,7.21-11.51,10.21-2.1,1.51-4.27,2.91-6.53,4.16-.24.13-.48.27-.73.4-.77-.1-1.54-.22-2.3-.33,8.63-4.28,16.14-10.72,22.42-17.97,3.45-3.99,6.59-8.24,9.43-12.68,2.13-3.32,4.22-6.74,5.68-10.4.49,0,.98-.02,1.47-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m130.48,101.97c-4.99,8.04-12.07,14.78-20.35,19.37-2.81,1.56-5.73,2.88-8.73,3.96.3-.59.62-1.19.97-1.79,3.5-1.37,6.87-3.07,10.04-5.12,6.48-4.19,12.05-9.68,16.25-16.11.59-.11,1.19-.21,1.82-.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m81.67,232.31l43.37,11.62,17.4-46.45-47.99-12.86c-13.17-3.53-26.71,4.29-30.23,17.46h0c-3.53,13.17,4.29,26.71,17.46,30.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m157.4,273.88c1.5,6.12,4.78,7.19,10.81,9.45.16.06.32.11.47.18.24.1.47.21.7.31h0c.31.15.6.32.88.49,3.66,2.16,5.62,5.75,6.66,8.71.14.39.26.77.37,1.12.64,2.18,1.03,3.87,1.03,3.87l-45.77,12.31-5.06-29.08,29.76-8c.05.22.1.44.15.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m140.79,277.65s-3.52,2.03-3.67,5.9c-.15,3.87-8.2,5.75-8.2,5.75l-1.4-8.08,13.27-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m176.93,293.01c.14.39.26.77.37,1.13l-45.41,12.36-.2-1.17,45.24-12.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "149.24 284.72 149.44 285.89 161.9 282.5 161.7 281.33 149.24 284.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "159.1 280.35 158.9 279.18 146.43 282.57 146.64 283.74 159.1 280.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "156.3 278.2 156.1 277.03 143.63 280.42 143.83 281.59 156.3 278.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m138.12,303.79l1.11.25c.03-.12,3.53-12.24,10.88-14.24l20.16-5.49c-.5-.29-1.02-.56-1.58-.79l-18.78,5.11c-8.06,2.2-11.64,14.63-11.79,15.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m128.98,194.47h0c-11.32,3.04-18.61,15.28-15.89,26.66l14.4,60.1,29.76-8-5.07-62.17c-.98-12-11.71-19.68-23.19-16.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "157.25 273.23 127.49 281.23 120.41 251.68 154.69 241.86 157.25 273.23"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m233.7,287.59c2.32,5.91,5.85,6.93,12.37,9.09.17.06.34.11.51.17.26.1.51.2.76.3h0c.34.15.66.3.97.47,4.05,2.07,6.53,5.53,7.98,8.39.19.37.36.74.53,1.08.93,2.1,1.54,3.73,1.54,3.73l-45.84,12.06-8.86-28.07,29.8-7.84c.08.22.16.43.24.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m216.98,291.3s-3.39,1.97-3.07,5.71-7.77,5.59-7.77,5.59l-2.45-7.8,13.29-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m256.29,306c.19.38.36.74.52,1.09l-45.45,12.11-.36-1.13,45.29-12.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "226.6 298.1 226.95 299.22 239.43 295.9 239.08 294.77 226.6 298.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "236.26 293.84 235.91 292.71 223.43 296.03 223.79 297.16 236.26 293.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "233.1 291.77 232.74 290.64 220.26 293.97 220.62 295.1 233.1 291.77"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m217.46,316.55l1.18.24c.02-.12,2.13-11.83,9.49-13.79l20.18-5.38c-.55-.28-1.13-.54-1.74-.76l-18.8,5.01c-8.07,2.15-10.23,14.17-10.32,14.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m194.41,211.01h0c-11.34,2.98-17.36,14.82-13.12,25.81l22.37,57.99,29.8-7.84-12.98-60.02c-2.51-11.59-14.56-18.96-26.07-15.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "233.46 286.96 203.66 294.8 192.66 266.29 226.91 256.68 233.46 286.96"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m107.98,251.81h24.88c11.82,0,21.41,9.59,21.41,21.41v33.33h-24.88c-11.82,0-21.41-9.59-21.41-21.41v-33.33h0Z",
    transform: "translate(370.46 84.63) rotate(76.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m231.22,264.53h9.41c11.06,0,20.04,8.98,20.04,20.04v32.2h-22.43c-11.06,0-20.04-8.98-20.04-20.04v-19.18c0-7.18,5.83-13.02,13.02-13.02Z",
    transform: "translate(602.02 188.99) rotate(113.82)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m252.46,21.93l-7.6,1.97c-2.58.67-4.13,3.3-3.46,5.88h0c.67,2.58,3.3,4.13,5.88,3.46l7.6-1.97c2.58-.67,4.13-3.3,3.46-5.88h0c-.67-2.58-3.3-4.13-5.88-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m252.83,22.3c-2.34.61-3.74,2.99-3.14,5.33.61,2.34,2.99,3.74,5.33,3.14,2.34-.61,3.74-2.99,3.14-5.33-.61-2.34-2.99-3.74-5.33-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m253.24,23.23c-.06.01-.11.02-.17.04-1.81.47-2.89,2.31-2.42,4.12.47,1.81,2.31,2.89,4.12,2.42.05-.01.11-.03.16-.05,1.71-.53,2.71-2.32,2.26-4.07-.45-1.75-2.2-2.82-3.95-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m253.24,23.23l1.69,6.53c1.71-.53,2.71-2.32,2.26-4.07-.45-1.75-2.2-2.82-3.95-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m253.53,25.01c-.84.22-1.35,1.08-1.13,1.92.22.84,1.08,1.35,1.92,1.13.84-.22,1.35-1.08,1.13-1.92s-1.08-1.35-1.92-1.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m215.33,38.49c.09.34.44.55.79.46l1.76-.46c.34-.09.55-.44.46-.79l-.66-2.55-3.01.78.66,2.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "172.95 8.16 177.63 26.21 186.58 23.89 174.53 7.75 172.95 8.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m279.27,8.62c-.73-.58-1.77-.91-2.56-1.7-2.71-2.68-10-3.81-17.74-1.8l-81.57,21.16c-1.45.38-2.72.29-2.35,1.74.11.44.28.87.49,1.29,1.91,3.8,7.6,6.49,13.96,8.04,7.06,1.72,14.94,2.03,19.42.87l59.12-15.34c10.41-2.7,14.56-7.7,15.03-10.15h0c.06-.33.06-.61,0-.83-.19-.68-1.46-2.28-3.8-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m271.86,13.1c-4.67-1.28-7.09-6.94-22.28-3-21.89,5.68-74.06,19.21-74.06,19.21.46.92,1.15,1.78,2.01,2.57.84.77,1.85,1.48,2.99,2.13,1.44.82,3.09,1.53,4.86,2.15h0c1.31.46,2.69.85,4.09,1.2,7.06,1.72,14.94,2.03,19.42.87l59.12-15.33c10.41-2.7,16.41-7.83,15.03-10.98,0,0-4.76,2.97-11.19,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m258.85,12.55l-76.11,19.74.11.43,76.11-19.74c.12-.03.19-.15.16-.27-.03-.12-.15-.19-.27-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m258.51,13.4l-77.01,19.98,1.24,1.54,76.23-19.77c.48-.13.77-.62.65-1.1-.13-.48-.62-.77-1.1-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m233.4,22.33l-47.63,12.36.54,2.09,49.04-12.72-.18-.68c-.2-.78-.99-1.24-1.77-1.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "172.29 8.33 176.98 26.38 185.93 24.06 173.88 7.92 172.29 8.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m164.95,35.14l23.22-6.02-.24-.93-24.15,6.26c.13.51.66.82,1.17.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m276.71,6.92l-8.78,2.28c.16.61.55,1.1,1.06,1.4s1.12.4,1.73.24l8.55-2.22c-.73-.58-1.59-1.16-2.56-1.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 277.09,
    y: 5.58,
    width: 0.35,
    height: 5.36,
    transform: "translate(107.78 227.85) rotate(-54.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 272.39,
    y: 7.5,
    width: 0.35,
    height: 4.14,
    transform: "translate(35.32 144.11) rotate(-31.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 269.91,
    y: 8.09,
    width: 0.35,
    height: 4.07,
    transform: "translate(26.73 127.71) rotate(-27.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m163.78,34.45l24.15-6.26s-3.87.26-12.05,2.38l-12.1,3.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "272.21 9.57 270.72 10.83 279.6 8.76 278.4 7.97 272.21 9.57"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m250.76,14.91c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m249.15,15.33c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m247.53,15.75c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m246.01,16.14c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m244.53,16.52c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m243.2,16.87c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m241.58,17.29c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m239.96,17.71h0c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23h0c.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m238.35,18.13c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m231.88,19.81c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m227.02,21.06c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m225.41,21.48h0c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23h0c.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m223.79,21.9c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m222.17,22.32c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23s.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m220.56,22.74c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23s.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m218.94,23.16c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23s.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m217.32,23.58c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m215.7,24c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23s.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m214.09,24.42h0c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23h0c.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m212.47,24.84c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m207.62,26.1c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23s.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m202.76,27.36c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m201.15,27.78c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m199.53,28.2h0c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23h0c.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m197.91,28.62c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m196.29,29.04h0c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23h0c.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m194.68,29.46c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m193.06,29.87c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m191.44,30.29c-.17.04-.27.22-.23.39l.16.6c.04.17.22.27.39.23.17-.04.27-.22.23-.39l-.16-.6c-.04-.17-.22-.27-.39-.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m239.22,22.18l-53.81,13.96c.92.32,1.87.61,2.84.88.41.11.83.22,1.25.32,7.06,1.72,14.94,2.03,19.42.87l54.97-14.26s-2.19-7.6-24.67-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m237.52,24.24l-49.27,12.78c.41.11.83.22,1.25.32,7.06,1.72,14.94,2.03,19.42.87l52-13.49s-1.79-6.09-23.4-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m271.75,17.64l-65.66,17.03c-4.97,1.29-13.67,1.19-21.41-.35-1.87-.37-3.69-.83-5.39-1.37-.02,0-.03-.01-.05-.02-.22-.07-.44-.14-.65-.21.02.01.04.03.06.04.02.02.04.03.06.05.18.13.36.26.55.39.04.03.08.05.12.08.39.26.8.51,1.22.75.04.02.07.04.11.06.22.12.44.24.67.36,0,0,.02,0,.02.01.22.11.46.23.69.34.03.01.05.03.08.04.24.12.49.23.73.33.02,0,.03.01.05.02.25.11.51.22.76.32,0,0,0,0,.02,0,.27.11.54.21.81.32.02,0,.03,0,.05.02,1.55.58,3.21,1.08,4.92,1.5,7.06,1.72,14.94,2.03,19.42.87l59.12-15.33h0c9.14-2.37,14.88-6.62,15.2-9.75-2.89,1.69-6.79,3.29-11.5,4.51,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m232.98,23.8l-76.03,19.72c-.84.22-1.34,1.07-1.12,1.9h0l78.81-20.44-.06-.24c-.18-.7-.9-1.12-1.6-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m196.32,33.31l-30.86,8,.39,1.5,32.36-8.39h0c-.21-.83-1.06-1.32-1.89-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m166.58,41.02l-9.62,2.5c-.84.22-1.34,1.07-1.13,1.91h0l12.66-3.28h0c-.22-.84-1.07-1.34-1.91-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m200.25,34.62c.91,3.5,4.48,5.59,7.97,4.69l4.92-1.28-1.82-7-11.25,2.92.17.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m233.69,26.59c.71-.17,1.14-.9.96-1.61l-78.81,20.44,77.86-18.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m209.96,35.12l22.1-5.73c1.93-.5,3.09-2.48,2.59-4.41h0l-25.6,6.64.91,3.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m215.96,31.4l-7.6,1.97c-2.58.67-4.13,3.3-3.46,5.88h0c.67,2.58,3.3,4.13,5.88,3.46l7.6-1.97c2.58-.67,4.13-3.3,3.46-5.88h0c-.67-2.58-3.3-4.13-5.88-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m215.96,31.4l-7.6,1.97c-2.58.67-4.12,3.3-3.46,5.88.09.36.22.7.39,1.01-.06-2.2,1.39-4.23,3.61-4.8l7.6-1.97c1.29-.33,2.59-.11,3.66.51.77.45,1.41,1.11,1.84,1.93,0-.36-.06-.71-.15-1.07-.33-1.29-1.16-2.32-2.22-2.94-1.06-.63-2.37-.85-3.66-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m216.32,31.77c-2.34.61-3.74,2.99-3.14,5.33.61,2.34,2.99,3.74,5.33,3.14,2.34-.61,3.74-2.99,3.14-5.33-.61-2.34-2.99-3.74-5.33-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m216.74,32.69c-.06.01-.11.02-.17.04-1.81.47-2.89,2.31-2.42,4.12.47,1.81,2.31,2.89,4.12,2.42.05-.01.11-.03.16-.05,1.71-.53,2.71-2.32,2.26-4.07-.45-1.75-2.2-2.82-3.95-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m216.74,32.69l1.69,6.53c1.71-.53,2.71-2.32,2.26-4.07-.45-1.75-2.2-2.82-3.95-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m217.03,34.48c-.84.22-1.35,1.08-1.13,1.92s1.08,1.35,1.92,1.13c.84-.22,1.35-1.08,1.13-1.92-.22-.84-1.08-1.35-1.92-1.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m182.21,41.05l7.71-2c1.28-.33,2.04-1.64,1.71-2.91l-12.34,3.2c.33,1.28,1.64,2.04,2.91,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m180.55,33.99l5.6-1.45c1.5-.39,2.4-1.92,2.01-3.43l-10.61,2.75c.84.77,1.85,1.48,2.99,2.13Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m184.74,18.35l-8.97,2.33c-1.27.33-2.04,1.63-1.71,2.9h0c.33,1.27,1.63,2.04,2.9,1.71l8.97-2.33c1.27-.33,2.04-1.63,1.71-2.9h0c-.33-1.27-1.63-2.04-2.9-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m185.23,18.91l-9.62,2.49c-1.09.28-1.75,1.4-1.47,2.49h0c.28,1.09,1.4,1.75,2.49,1.47l9.62-2.49c1.09-.28,1.75-1.4,1.47-2.49h0c-.28-1.09-1.4-1.75-2.49-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m184.92,18.53c-1.15.3-1.85,1.48-1.55,2.63.3,1.15,1.48,1.85,2.63,1.55,1.15-.3,1.85-1.48,1.55-2.63-.3-1.15-1.48-1.85-2.63-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m185.12,18.99s-.05.01-.08.02c-.89.23-1.43,1.14-1.2,2.03s1.14,1.43,2.03,1.2c.03,0,.05-.02.08-.02.84-.26,1.34-1.15,1.12-2.01-.22-.86-1.09-1.39-1.95-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m185.12,18.99l.84,3.22c.84-.26,1.34-1.15,1.12-2.01-.22-.86-1.09-1.39-1.95-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m185.26,19.87c-.42.11-.66.53-.56.95.11.42.53.66.95.56s.66-.53.56-.95c-.11-.42-.53-.66-.95-.56Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m178.37,17.17l-3.54.92.41,1.59,3.54-.92c.44-.11.7-.56.59-1-.11-.44-.56-.7-1-.59Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeistungenPapa);
export default __webpack_public_path__ + "static/media/leistungen-papa.c5a3b4ce2b158aa422cf7fb12ba1f482.svg";
export { ForwardRef as ReactComponent };